import React, { useState } from 'react';
import { FaSpinner } from 'react-icons/fa';

const CollaborateBanner = () => {
  const [formData, setFormData] = useState({});
  const [status, setStatus] = useState('idle'); // idle, processing, success, error
  const [message, setMessage] = useState(null);

  const handleFormChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    setMessage(null);
    setStatus('processing');

    try {
      const response = await fetch('http://localhost:4000/api/collaboration/submit', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });

      const data = await response.json();

      if (response.ok) {
        setStatus('success');
        setMessage(data.message);
        setFormData({}); // Clear form on success
      } else {
        setStatus('error');
        setMessage(data.message || 'Submission failed. Please check your network.');
      }
    } catch (error) {
      setStatus('error');
      setMessage('Network error. Could not reach the server.');
    }
  };

  return (
    <section
      className="relative min-h-screen flex items-center bg-black py-16 px-4 sm:px-6 lg:px-8"
      style={{
        backgroundImage: "url('/assets/2025-BMW-Background.jpg')",
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      <div className="absolute inset-0 bg-black opacity-70"></div>

      <div className="relative z-10 max-w-md lg:max-w-lg xl:max-w-xl mx-auto lg:ml-8 p-6 md:p-8 rounded-2xl shadow-2xl">
        <h2 className="text-3xl lg:text-4xl font-bold mb-6 text-white">
          WANT TO <span className="text-amber-400">COLLAB</span> WITH US?
        </h2>
        
        {/* Message Display Section */}
        {message && (
          <div className={`p-3 rounded-lg mb-4 font-semibold ${
            status === 'success' ? 'bg-green-600 text-white' : 'bg-red-600 text-white'
          }`}>
            {message}
          </div>
        )}
        
        <form onSubmit={handleFormSubmit} className="space-y-4 md:space-y-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <input
                type="text"
                name="fullName" // <-- ADDED NAME
                placeholder="Full Name*"
                onChange={handleFormChange}
                required
                value={formData.fullName || ''}
                className="w-full p-3 bg-transparent border-b-2 border-amber-400 focus:outline-none text-white placeholder-slate-400"
              />
            </div>
            <div>
              <input
                type="email"
                name="email" // <-- ADDED NAME
                placeholder="Email ID*"
                onChange={handleFormChange}
                required
                value={formData.email || ''}
                className="w-full p-3 bg-transparent border-b-2 border-amber-400 focus:outline-none text-white placeholder-slate-400"
              />
            </div>
            <div>
              <input
                type="tel"
                name="phoneNumber" // <-- ADDED NAME
                placeholder="Phone Number"
                onChange={handleFormChange}
                value={formData.phoneNumber || ''}
                className="w-full p-3 bg-transparent border-b-2 border-amber-400 focus:outline-none text-white placeholder-slate-400"
              />
            </div>
            <div>
              <input
                type="text"
                name="industry" // <-- ADDED NAME
                placeholder="Industry"
                onChange={handleFormChange}
                value={formData.industry || ''}
                className="w-full p-3 bg-transparent border-b-2 border-amber-400 focus:outline-none text-white placeholder-slate-400"
              />
            </div>
          </div>
          <div>
            <textarea
              name="message" // <-- ADDED NAME
              placeholder="Message"
              rows="4"
              onChange={handleFormChange}
              value={formData.message || ''}
              className="w-full p-3 bg-transparent border-b-2 border-amber-400 focus:outline-none text-white placeholder-slate-400 resize-none"
            ></textarea>
          </div>
          <button
            type="submit"
            disabled={status === 'processing'}
            className="w-auto px-8 py-3 bg-amber-400 text-black font-bold rounded-md relative overflow-hidden group flex items-center justify-center space-x-2"
          >
            <span className="relative z-10">
              {status === 'processing' ? <FaSpinner className="animate-spin" /> : 'SUBMIT'}
            </span>
            <span className="absolute inset-0 bg-amber-500 transform scale-x-0 origin-left transition-transform duration-300 group-hover:scale-x-100"></span>
          </button>
        </form>
      </div>
    </section>
  );
};

export default CollaborateBanner;